export function getEtherscanLink(contractAddress: string): string {
  return `https://etherscan.io/address/${contractAddress}`
}
